Auth = require 'db/auth'
MemberState = require 'view-models/member-state'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/member_cards_group'
track = require 'debug/track'
_ = require 'underscore'

module.exports = class MemberCardsGroupPopOverView extends View
  viewTitleKey: 'filter cards'

  initialize: ->
    @listenTo MemberState, 'change:cardsPageGroup', ->
      @render()

  events:
    'click .js-set-group': 'setGroup'

  render: ->
    orgs =
      if Auth.isMe(@model)
        @model.organizationList.models
      else
        # We may be dealing with a deactivated user, so we can't use @model.organizationList
        @modelCache.find('Organization', (org) => org.getMembershipFor(@model)?)

    @$el.html(template({
      group: MemberState.getCardsPageGroup()
      organizations:
        _.chain(orgs)
        .map (org) ->
          id: org.id
          name: org.get('displayName')
        .sortBy ({ name }) -> name.toLowerCase()
        .value()
    }))

    @

  setGroup: (e) ->
    group = @$(e.currentTarget).attr('data-group')

    Util.stop(e)
    MemberState.setCardsPageGroup(group)
    PopOver.hide()
    track("Member View", "Cards Page", "Group", group)
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-cards-group-pop-over-view.coffee